import GccAutoUpdate from "./GccAutoUpdate";

export default GccAutoUpdate;
